// descontos-lista-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Mude a busca, o tipo, o posto ou o combustível para ver mais descontos.": "Cambie la búsqueda, el tipo, la estación o el combustible para ver más descuentos.",
};

export default catalogo;
